import type { CallParticipant } from '../../../types/voice-call'

/**
 * Participant ids for a room END's history payload. Invitees who declined
 * (or were busy) stay in the host's roster with state 'declined' so the UI can
 * show them, but they were never in the call and must not get a group-call
 * record. `joined` (e.g. the live Chime roster) is always kept.
 */
export function roomEndParticipantIds(
  participants: ReadonlyArray<Pick<CallParticipant, 'userId' | 'state'>>,
  joined: ReadonlyArray<Pick<CallParticipant, 'userId'>> = [],
): string[] {
  return Array.from(
    new Set(
      [...joined, ...participants.filter((p) => p.state !== 'declined')]
        .map((p) => p.userId)
        .filter(Boolean),
    ),
  )
}
